<template>
  <v-card>
    <v-card-text>
      <v-form v-model="valid" ref="form" id="tambahkan-pesanan-pengiriman" lazy-validation>
        <h3 style="margin: 0% auto;"><b>Gapoktan Baru</b></h3>
        <small>Gapoktan > Tambahkan Gapoktan</small>
        <v-layout row wrap>

          <v-flex lg12 sm12>
            <v-text-field label="Nama Kelompok Tani" name="namaKelompokTani" v-model="namaKelompokTani">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Desa" name="desa" v-model="desa">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Kecamatan" name="kecamatan" v-model="kecamatan">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Kabupaten" name="kabupaten" v-model="kabupaten">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              v-model="selectProvinsi"
              :items="tipeProvinsi"
              label="Pilih Provinsi"
            ></v-select>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Nama Ketua Kelompok Tani" name="namaKetuaKelompokTani" v-model="namaKetuaKelompokTani">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Kontak" name="kontakKetuaKelompokTani" v-model="kontakKetuaKelompokTani">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Perkiraan Hasil Panen Satu Periode" name="waktuPanen" v-model="waktuPanen">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Komoditas" name="komoditasPanen" v-model="komoditasPanen">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Perkiraan Model yang Digunakan" name="modelPanen" v-model="modelPanen">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Jenis Bantuan Pemerintah" name="jenisBantuanPemerintah" v-model="jenisBantuanPemerintah">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Sumber Benih" name="sumberBenih" v-model="sumberBenih">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Tujuan Instansi Pemasaran" name="tujuanInstansiPemasaran" v-model="tujuanInstansiPemasaran">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Sumber Saprotan" name="sumberSaprotan" v-model="sumberSaprotan">
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Perkiraan Stock Hasil Pemanenan" name="stockHasilPanen" v-model="stockHasilPanen">
            </v-text-field>
          </v-flex>
        </v-layout>        

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="back">Batal</v-btn>
          <v-btn color="primary" form="tambahkan-pesanan-pengiriman" @click="getGapoktan">Tambahkan Gapoktan</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import moment,{ locale } from 'moment'

export default {
  components: {
  },
  data: () => ({
    valid: true,
    date: null,
    modal: false ,

    namaKelompokTani: null,
    desa: null,
    kecamatan: null,
    kabupaten: null,
    selectProvinsi: null,
    tipeProvinsi: [
      'Aceh',
      'Bali',
      'Banten',
      'Bengkulu',
      'Daerah Istimewa Yogyakarta',
      'Gorontalo',
      'Jakarta',
      'Jambi',
      'Jawa Barat',
      'Jawa Tengah',
      'Jawa Timur',
      'Kalimantan Barat',
      'Kalimantan Selatan',
      'Kalimantan Tengah',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'Lampung',
      'Maluku',
      'Maluku Utara',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Papua',
      'Papua Barat',
      'Riau',
      'Sulawesi Barat',
      'Sulawesi Selatan',
      'Sulawesi Tengah',
      'Sulawesi Tenggara',
      'Sulawesi Utara',
      'Sumatra Barat',
      'Sumatra Selatan',
      'Sumatra Utara'
    ],  

    namaKetuaKelompokTani: null,
    kontakKetuaKelompokTani: null,
    waktuPanen: null,
    komoditasPanen: null,
    modelPanen: null,
    jenisBantuanPemerintah: null,
    sumberBenih: null,
    tujuanInstansiPemasaran: null,
    sumberSaprotan: null,
    stockHasilPanen: null,

    currentDateGapoktan: null,
  }),

  computed: {
    tipeDocs() {
      return [
        'Dokumen Usaha Dagang Perantara',
        this.kodePenjualan
      ]
    }
  },

  methods: {

    closeDialog () {
      this.$parent.isActive = false;
    },

    back(){
      window.getApp.$emit('APP_KOMODITAS');
    },

    saveTemplate(){
      // window.getApp.$emit('APP_SIMPAN_TEMPLATE');
    },

    getGapoktan (){
      localStorage.gapoktanNamaKelompokTani = this.namaKelompokTani,
      localStorage.gapoktanDesa = this.desa,
      localStorage.gapoktanKecamatan = this.kecamatan,
      localStorage.gapoktanKabupaten = this.kabupaten,
      localStorage.gapoktanProvinsi = this.selectProvinsi,
      localStorage.gapoktanNamaKetuaKelompokTani = this.namaKetuaKelompokTani,
      localStorage.gapoktanKontakKetuaKelompokTani = this.kontakKetuaKelompokTani,
      localStorage.gapoktanWaktuPanen = this.waktuPanen,
      localStorage.gapoktanKomoditasPanen = this.komoditasPanen,
      localStorage.gapoktanModelPanen = this.modelPanen,
      localStorage.gapoktanJenisBantuanPemerintah = this.jenisBantuanPemerintah,
      localStorage.gapoktanSumberBenih = this.sumberBenih,
      localStorage.gapoktanTujuanInstansiPemasaran = this.tujuanInstansiPemasaran,
      localStorage.gapoktanSumberSaprotan = this.sumberSaprotan,
      localStorage.gapoktanStockHasilPanen = this.stockHasilPanen,

      localStorage.gapoktanID = 'GAP-190400001'
      localStorage.currentDateGapoktan = moment().format('DD-MM-YYYY');

      window.getApp.$emit('APP_GAPOKTAN');

    }
  }
};
</script>

<style lang="stylus" scoped>
  .quill
    height : 360px
</style>
